import React, {useEffect, useState} from 'react';
import Nowruz from "../../../Image/login image.jpg";
import "./LoginForm.css";
import Grid from "@mui/material/Grid";
import {SnackbarProvider, useSnackbar} from 'notistack';
import CircularProgress from "@mui/material/CircularProgress";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import Notifier from './Notifier';
import {strings} from "../../../strings";
import {useHistory} from "react-router";
import {setUser, setToken} from "../../../stores/base/baseSlice";
import {notification} from "../../functions/notification/notificationFunction";

function LoginForm(props) {
    const [eye, SetEye] = useState("password");
    const [typeForm, SetTypeForm] = useState("login");
    const [loading, SetLoading] = useState(false);
    const [userName,SetUserName] = useState("");
    const [password,SetPassword] = useState("");
    const [isChecked,SetIsChecked] = useState(false);
    const [phone, SetPhone] = useState("")
    const dispatch = useDispatch();

    const history = useHistory();

    function GetTypeForm(data) {
        SetLoading(true)
        SetTypeForm(data);
        setTimeout(() => SetLoading(false), 500)

    }

    function ShowPass() {
        if (eye === "password") {
            SetEye("text")
        } else {
            SetEye("password")
        }
    }

    function onChangeCheckbox(e) {
        SetIsChecked(e.target.checked);
    }

    async function handleLogin(e){
        e.preventDefault();
        if(userName === "" || password === ""){
            dispatch(notification("error","خوش آمدید",<h3>نام کاربری و پسورد خود را وارد کنید</h3>,false))
        }else {
            await axios.post(strings.baseUrl+`auth/management/confirm?email=${userName}&password=${password}`)
                .then(result=>{
                    if(result.data.status_code === 200){
                        const tok = `Bearer ${result.data.data.token}`
                        dispatch(setToken({token: tok}))
                        dispatch(setUser(result.data.data.admin))
                        history.replace('/dashboard')
                    }else dispatch(notification("error","خوش آمدید",<h3>${result.data.message}</h3>,false))
                })
                .catch(error=>{
                    console.log(error);
                })
        }
    }

    function getCodeCrossing(e){
        e.preventDefault();
        if( phone === "" ){
            dispatch(notification("error","شماره موبایل همراه خود را وارد کنید"))
        }else if( phone.length !== 11){
            dispatch(notification("error", "شماره موبایل وارد شده معتبر نیست"))
        }
    }

    useEffect(() =>{

    }, [])
    return (
        <React.Fragment>
            <Grid className="DivFormLogin d-flex flex-column flex-md-row">
                <Grid item lg={6} className="position-relative">
                    <Notifier />
                    {loading ?
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <CircularProgress />
                        </div>
                        :
                        <div className="DivInputs">
                            <p>سامانه مدیریت فرآیند مرکز نشر</p>
                            {typeForm === "login" &&
                            <form
                                onSubmit={(e)=>handleLogin(e)}
                                className="d-flex flex-column align-items-center"
                            >
                                <div className="d-flex flex-row w-100 justify-content-center
                                                align-items-center DivUserName"
                                >
                                    <i className="fa fa-user-circle"/>
                                    <input
                                        type="email"
                                        name="username"
                                        placeholder="ایمیل"
                                        className="UserName"
                                        onChange={(e)=>SetUserName(e.target.value)}
                                    />
                                </div>
                                <div className="d-flex flex-row w-100 justify-content-center
                                                align-items-center DivPassWord"
                                >
                                    <i className="fa fa-lock"/>
                                    <input
                                        type={eye}
                                        name="password"
                                        placeholder="رمز عبور"
                                        className="UserName"
                                        onChange={(e)=>SetPassword(e.target.value)}
                                    >
                                    </input>
                                    <i
                                        className={`fas EyeSlash ${eye === "password"
                                            ? "fa-eye-slash" :
                                            "fa-eye"}`}
                                        onClick={ShowPass}
                                    />
                                    <i className="Exclamation fa fa-info"/>
                                </div>
                                <div className="SavePassWord w-100 d-flex
                                justify-content-center align-items-center"
                                >
                                    <input type="checkbox" checked={isChecked} name="lsRememberMe" onChange={(e)=>onChangeCheckbox(e)} />
                                    <label
                                        htmlFor=""
                                        className="w-75 mr-2"
                                    >به خاطر سپاری رمز کاربری</label>
                                </div>
                                <div className="d-flex w-85  DivLoginButton
                                align-items-start"
                                >
                                    <button
                                        className="mr-2"
                                        onClick={(e)=>handleLogin(e)}
                                    >ورود به سامانه</button>
                                    <p
                                        className="mr-4"
                                        onClick={() => GetTypeForm("forgetPassword")}
                                    >
                                        فراموشی رمز عبور</p>
                                </div>
                            </form>
                            }
                            {typeForm === "forgetPassword" &&
                            <form
                                onSubmit={(e)=>getCodeCrossing(e)}
                                className="d-flex flex-column align-items-center"
                            >
                                <div className="d-flex flex-row w-100 justify-content-center
                                                align-items-center DivUserName"
                                >
                                    <i className="fas fa-phone-square"/>
                                    <input
                                        type="text"
                                        placeholder="شماره همراه"
                                        className="UserName"
                                        onChange={(e)=>SetPhone(e.target.value)}
                                    />
                                </div>
                                <div className="d-flex w-85  DivLoginButton justify-content-between
                                align-items-center"
                                >
                                    <button
                                        onClick={(e)=>getCodeCrossing(e)}
                                        className="mr-2"
                                    >دریافت کلمه عبور</button>
                                    <h3
                                        className="m-0"
                                        onClick={() => GetTypeForm("login")}
                                    >بازگشت</h3>
                                </div>
                            </form>
                            }
                        </div>
                    }
                </Grid>
                <Grid item lg={6}>
                    <img src={Nowruz} className="Nowruz w-100 h-100" alt=""/>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default function IntegrationNotistack() {
    return (
        <SnackbarProvider maxSnack={3} anchorOrigin={{vertical:"top",horizontal:"center"}}>
            <LoginForm/>
        </SnackbarProvider>
    );
}